<template>
  <v-container style="max-width:100vw;" class="mb-6">
    <v-row class="ma-0 pa-0">
      <v-card-title style="font-weight:300; font-family: 'Ergon'!important;">Reporte Mensual</v-card-title>
    </v-row>
    <v-row class="ma-0 pl-4 pr-12">
      <v-select
        outlined
        rounded
        dense
        class="mr-12 custom-select"
        item-text="label"
        :items="periods"
        item-value="value"
        v-model="filter"
      />
    </v-row>
    <v-card v-if="showReport" id="chart" class="elevation-0" style="background:transparent; margin-left:-10px;">
      <apexchart type="bar" :height="chartHeight" :options="chartOptions" :series="series" />
    </v-card>
    <v-row class="ma-0 pt-12 mt-12" v-else>
      <v-spacer />
      <div style="text-align:center;">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
        <br />
        <v-card-title>Cargando...</v-card-title>
      </div>
      <v-spacer />
    </v-row>
  </v-container>
</template>

<script>
import dates from "../../mixins/dates"
import axios from "axios"

export default {
  mixins: [dates],
  data () {
    return {
      filter: 3,
      showReport: false,
      series: [{ name: "Comisión", data: [] }],
      x: [],
      y: [],
      chartOptions: {
        chart: { background: "transparent", toolbar: { show: true } },
        plotOptions: { bar: { borderRadius: 35, borderRadiusApplication: "end" } },
        colors: ["#f4bfa7"],
        dataLabels: { enabled: false },
        tooltip: {
          y: { formatter: (y) => y.toLocaleString("es-MX", { style: "currency", currency: "MXN" }) }
        },
        xaxis: {
          type: "category",
          categories: [],
          labels: { rotate: 0, offsetY: 8, style: { fontSize: "13px", fontWeight: 900 } }
        },
        yaxis: { labels: { show: false } },
        grid: { borderColor: "#EAEAEA", yaxis: { lines: { show: true } }, xaxis: { lines: { show: false } } },
        legend: { show: false }
      }
    }
  },
  watch: {
    filter: {
      handler () {
        this.showReport = false
        this.renderData()
        this.$nextTick(() => { this.showReport = true })
      },
      deep: true
    }
  },
  created () {
    this.showReport = false
    axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/influencer-collabs?type=report").then(resp => {
      const data = resp.data
      this.y = data.map(d => d.influencer_amount)
      this.x = data.map(d => this.cropMonthFormat(d.month) + ' ' + d.date.slice(2,4))
      this.renderData()
      this.showReport = true
    })
  },
  methods: {
    renderData () {
      const n = Math.min(this.filter, this.y.length, this.x.length)

      const yy = this.y.slice(0, n)
      const xx = this.x.slice(0, n)
      const ordered_yy = new Array(n)
      const ordered_xx = new Array(n)

      const horizontal = n > 3

      if(!horizontal){
        for (let i = 0; i < n; i++) {
          ordered_yy[i] = yy[n - 1 - i]
          ordered_xx[i] = xx[n - 1 - i]
        }
      }else{
        for (let i = 0; i < n; i++) {
          ordered_yy[i] = yy[i]
          ordered_xx[i] = xx[i]
        }
      }

      this.series[0].data = ordered_yy

      this.chartOptions.plotOptions.bar.borderRadius = this.filter <12 ? 35 : 12
      this.chartOptions.plotOptions.bar.borderRadiusApplication = "end"
      this.chartOptions.xaxis.categories = this.buildCategories(ordered_xx, ordered_yy)

      if (horizontal) {
        this.chartOptions.plotOptions.bar.horizontal = true
        this.chartOptions.xaxis.labels = { show: false }
        this.chartOptions.yaxis = { labels: { show: true, style: { fontSize: "13px", fontWeight: 900 } } }
      } else {
        this.chartOptions.plotOptions.bar.horizontal = false
        this.chartOptions.xaxis.labels = { rotate: 0, offsetY: 8, style: { fontSize: "13px", fontWeight: 900 } }
        this.chartOptions.yaxis = { labels: { show: false } }
      }
    },
    buildCategories (labels, values) {
      return labels.map((lbl, i) => [
        lbl,
        Number(values[i] || 0).toLocaleString("es-MX", { style: "currency", currency: "MXN" })
      ])
    }
  },
  computed: {
    chartHeight () {
      return 600
    },
    periods () {
      return [
        { label: "Últimos 3 meses", value: 3 },
        { label: "Últimos 6 meses", value: 6 },
        { label: "Últimos 12 meses", value: 12 }
      ]
    }
  }
}
</script>

<style>
.custom-select.v-text-field--outlined fieldset { border-color: rgb(244 174 142)!important; }
.custom-select.theme--light.v-select .v-select__selections, .custom-select .theme--light.v-icon  { color: rgb(244 174 142)!important; font-weight: 500; }
.theme--light.v-list { background: rgb(244 244 244 / 90%)!important; }
.v-menu__content{ border-radius: 20px!important; box-shadow: none!important; border: solid 1px #f4ae8e!important; }
.apexcharts-menu{ border: solid 1px #f4ae8e!important; border-radius: 20px!important; background: rgb(244 244 244 / 90%)!important; width:125px; padding:10px!important; }

/* 2 líneas en vertical (x-axis) */
.apexcharts-xaxis-texts-g{ transform: translateY(-10px)!important; }
.apexcharts-xaxis text tspan:nth-child(1){ font-weight:900; }
.apexcharts-xaxis text tspan:nth-child(2){ font-weight:500; font-size:12px; }

/* 2 líneas en horizontal (y-axis) */
.apexcharts-yaxis text tspan:nth-child(1){ font-weight:900; }
.apexcharts-yaxis text tspan:nth-child(2){ font-weight:500; font-size:12px; }
</style>
